export default "__VITE_ASSET__D$hAoWAr__"